package com.kyant.backdrop.catalog

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import kotlinx.browser.document
import kotlinx.browser.window

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    val root =
        document.getElementById("liquid-nav-root")
            ?: document.getElementById("app")
            ?: document.body
            ?: return
    val topWindow = window.asDynamic().top
    val pathname =
        ((topWindow?.location?.pathname as? String)
            ?: window.location.pathname)
    val normalizedPathname =
        when {
            pathname.isBlank() -> "/"
            pathname == "/index.html" -> "/"
            else -> pathname.removeSuffix("/index.html").removeSuffix("/").ifBlank { "/" }
        }
    ComposeViewport(root) {
        MainContent(
            pathname = normalizedPathname,
            onNavigate = { href ->
                val current =
                    ((topWindow?.location?.pathname as? String)
                        ?: window.location.pathname)
                        .removeSuffix("/index.html")
                        .removeSuffix("/")
                        .ifBlank { "/" }
                val target = href.removeSuffix("/").ifBlank { "/" }
                if (current != target) {
                    if (topWindow != null) {
                        topWindow.location.href = href
                    } else {
                        window.location.href = href
                    }
                }
            }
        )
    }
}
